import { render, staticRenderFns } from "./OfflineClipboard.vue?vue&type=template&id=f5c1b738&"
import script from "./OfflineClipboard.vue?vue&type=script&lang=js&"
export * from "./OfflineClipboard.vue?vue&type=script&lang=js&"
import style0 from "./OfflineClipboard.vue?vue&type=style&index=0&id=f5c1b738&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports